// D-212: "Message the DIGU team" from /support. Works signed out (a reply email is needed) and signed in (the account
// is attached). Stored server-side; admins read them in the Inbox (phone) and Admin › Messages (console).
import { z } from "zod";
export const SUPPORT_TOPICS = ["account", "boli", "bug", "player", "other"];
export const SUPPORT_TOPIC_WORDS = { account: "Account", boli: "Payments and Boli", bug: "A bug", player: "A player", other: "Something else" };
export const SUPPORT_BODY_MAX = 2000;
/** Messages one address may send in ten minutes. */
export const SUPPORT_PER_10_MIN = 5;
/** POST /support/messages. `email` is required when signed out. */
export const SupportPost = z.object({
    topic: z.enum(SUPPORT_TOPICS, { message: "Choose what it's about." }),
    body: z.string().trim().min(10, "Tell us a little more: at least 10 characters.").max(SUPPORT_BODY_MAX, `Keep it under ${SUPPORT_BODY_MAX} characters.`),
    email: z.string().trim().max(200).email("That email address doesn't look right. Check it and try again.").optional().or(z.literal("").transform(() => undefined)),
    name: z.string().trim().max(60).optional(),
});
/** POST /admin/support/:id/close */
export const SupportClose = z.object({ note: z.string().trim().max(280).optional() });
//# sourceMappingURL=support.js.map